import { LinearProgress } from "@mui/material";
import { SingleFieldList, useListContext } from "react-admin";

export const MySingleFieldList = ({ noReferences, ...props }) => {
  const { data, isLoading } = useListContext(props);

  if (isLoading) return <LinearProgress />;

  if (!(data && data.length) && noReferences) return noReferences;

  return <SingleFieldList {...props} />;
};
